export default __webpack_public_path__ + "static/media/Frame 1.1904894c.jpg";